import * as types from './mutation-types'

const state = {
  resources: {
    data: [],
  },
  disabledResources: {
    data: [],
  },
  page: {
    attributes: {
      title: '',
    },
  },
  link: {
    attributes: {
      title: '',
    },
  },
  createLinkModalIsOpen: false,
  deleteLinkModal: {
    open: false,
    link: {
      uuid: '',
      attributes: {
        title: 'Link',
      },
    },
  },
  disableLinkModal: {
    open: false,
    link: {
      uuid: '',
      attributes: {
        title: 'Link',
      },
    },
  },
  enableLinkModal: {
    open: false,
    link: {
      uuid: '',
      attributes: {
        title: 'Link',
      },
    },
  },
  editLinkModal: {
    open: false,
    link: {
      uuid: '',
      attributes: {
        title: 'Link',
      },
    },
  },
  deletePageModal: {
    open: false,
    page: {
      uuid: '',
      attributes: {
        title: 'Page',
      },
    },
  },
  disablePageModal: {
    open: false,
    page: {
      uuid: '',
      attributes: {
        title: 'Page',
      },
    },
  },
  enablePageModal: {
    open: false,
    page: {
      uuid: '',
      attributes: {
        title: 'Page',
      },
    },
  },
  categories: {
    data: [],
  },
}

const mutations = {
  [types.RESOURCE_SET_PAGE](state, Page) {
    state.page = Page
  },
  [types.RESOURCE_SET_LINK](state, Link) {
    state.link = Link
  },
  [types.RESOURCE_SET_RESOURCES](state, Resources) {
    state.resources = Resources
  },
  [types.RESOURCE_SET_DISABLED_RESOURCES](state, Resources) {
    state.disabledResources = Resources
  },
  [types.RESOURCE_CLOSE_CREATE_LINK_MODAL](state) {
    state.createLinkModalIsOpen = false
  },
  [types.RESOURCE_OPEN_CREATE_LINK_MODAL](state) {
    state.createLinkModalIsOpen = true
  },
  [types.RESOURCE_CLOSE_DELETE_LINK_MODAL](state) {
    state.deleteLinkModal.open = false
    state.deleteLinkModal.link = {
      uuid: '',
      attributes: {
        title: 'Link',
      },
    }
  },
  [types.RESOURCE_OPEN_DELETE_LINK_MODAL](state, Link) {
    state.deleteLinkModal.open = true
    state.deleteLinkModal.link = Link
  },
  [types.RESOURCE_CLOSE_ENABLE_LINK_MODAL](state) {
    state.enableLinkModal.open = false
    state.enableLinkModal.link = {
      uuid: '',
      attributes: {
        title: 'Link',
      },
    }
  },
  [types.RESOURCE_OPEN_ENABLE_LINK_MODAL](state, Link) {
    state.enableLinkModal.open = true
    state.enableLinkModal.link = Link
  },
  [types.RESOURCE_CLOSE_DISABLE_LINK_MODAL](state) {
    state.disableLinkModal.open = false
    state.disableLinkModal.link = {
      uuid: '',
      attributes: {
        title: 'Link',
      },
    }
  },
  [types.RESOURCE_OPEN_DISABLE_LINK_MODAL](state, Link) {
    state.disableLinkModal.open = true
    state.disableLinkModal.link = Link
  },
  [types.RESOURCE_CLOSE_EDIT_LINK_MODAL](state) {
    state.editLinkModal.open = false
    state.editLinkModal.link = {
      uuid: '',
      attributes: {
        title: 'Link',
      },
    }
  },
  [types.RESOURCE_OPEN_EDIT_LINK_MODAL](state, Link) {
    state.editLinkModal.open = true
    state.editLinkModal.link = Link
  },
  [types.RESOURCE_CLOSE_DELETE_PAGE_MODAL](state) {
    state.deletePageModal.open = false
    state.deletePageModal.page = {
      uuid: '',
      attributes: {
        title: 'Page',
      },
    }
  },
  [types.RESOURCE_OPEN_DELETE_PAGE_MODAL](state, Page) {
    state.deletePageModal.open = true
    state.deletePageModal.page = Page
  },
  [types.RESOURCE_CLOSE_ENABLE_PAGE_MODAL](state) {
    state.enablePageModal.open = false
    state.enablePageModal.page = {
      uuid: '',
      attributes: {
        title: 'Page',
      },
    }
  },
  [types.RESOURCE_OPEN_ENABLE_PAGE_MODAL](state, Page) {
    state.enablePageModal.open = true
    state.enablePageModal.page = Page
  },
  [types.RESOURCE_CLOSE_DISABLE_PAGE_MODAL](state) {
    state.disablePageModal.open = false
    state.disablePageModal.page = {
      uuid: '',
      attributes: {
        title: 'Link',
      },
    }
  },
  [types.RESOURCE_OPEN_DISABLE_PAGE_MODAL](state, Page) {
    state.disablePageModal.open = true
    state.disablePageModal.page = Page
  },
  [types.RESOURCE_SET_CATEGORIES](state, Categories) {
    state.categories = Categories.data
  },
}

export default {
  state,
  mutations,
}